import { Tag } from 'antd'
import type { CSSProperties } from 'react'

export interface StatusConfig {
  color: string
  label: string
}

interface StatusBadgeProps<T extends string> {
  status: T
  configMap: Record<T, StatusConfig>
  style?: CSSProperties
}

export function StatusBadge<T extends string>({
  status,
  configMap,
  style,
}: StatusBadgeProps<T>): React.JSX.Element {
  const config = configMap[status]
  if (!config) return <Tag style={style}>{String(status)}</Tag>
  return (
    <Tag color={config.color} style={style}>
      {config.label}
    </Tag>
  )
}
